import React from "react";
import { connect } from "react-redux";

const JoinNowSection = ({ merchantData, appStateData }) => {
  let { merchant } = merchantData;
  const { customerId, shopDomain } = appStateData;
  const isGermanLang = shopDomain === "nui-cosmetics.myshopify.com";

  let parentLocation =
    window.location != window.parent.location
      ? document.referrer
      : document.location.href;

  return (
    <div className="joinNow-sec-wrapper">
      <div className="joinNow-background-container">
        <div className="joinNow-sec-content">
          <div className="joinNow-text-container">
            <h1 className="joinNow-primary-text">{merchant?.name}</h1>
            <p className="joinNow-secondary-text">
              {isGermanLang
                ? "Als Prämienmitglied kommen Sie dem exklusiven Verdienen näher Prämien bei jedem Einkauf."
                : merchant?.currentPlan?.planName !== "free" &&
                  merchant?.customWidgetTheme?.textCustomization
                ? merchant?.customWidgetTheme?.textCustomization?.programDesc
                : "As a rewards member, you’ll get closer to earning exclusive rewards every time you shop."}
            </p>
          </div>

          {!customerId && (
            <div className="joinNow-buttons-sec">
              <button
                onClick={() => {
                  window.open(`${parentLocation}account/register`, "_PARENT");
                }}
                className="joinNow-button"
              >
                {isGermanLang
                  ? "Jetzt Mitglied werden"
                  : merchant?.currentPlan?.planName !== "free" &&
                    merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization
                      ?.joinNowButton
                  : "JOIN NOW"}
              </button>
              <p className="joinNow-already-info-text">
                {isGermanLang
                  ? "Bereits Mitglied?"
                  : merchant?.currentPlan?.planName !== "free" &&
                    merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization
                      ?.alreadyHaveAnAccount
                  : "Already a member?"}{" "}
                <a
                  href={`${parentLocation}account/login`}
                  target="_PARENT"
                  className="joinNow-signIn-link"
                >
                  {isGermanLang
                    ? "Anmelden"
                    : merchant?.currentPlan?.planName !== "free" &&
                      merchant?.customWidgetTheme?.textCustomization
                    ? merchant?.customWidgetTheme?.textCustomization?.signIn
                    : "Sign In"}
                </a>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  customerData: state.CustomerReducer,
  merchantData: state.MerchantReducer,
  appStateData: state.AppstateReducer,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(JoinNowSection);
